<template>
  <div class="layout-logo-container collapse">
    <transition name="layout-logo-fade">
      <router-link key="collapse" to="/">
        <img src="~/assets/logo.png" class="layout-logo" />
      </router-link>
    </transition>
  </div>
</template>

<style lang="scss" scoped>
.layout-logo-container {
  position: relative;
  width: 100%;
  height: var(--header-height);
  line-height: var(--header-height);
  background-color: transparent;
  text-align: center;
  overflow: hidden;

  .layout-logo {
    // width: 32px;
    height: 36px;
    vertical-align: middle;
    display: inline-block;
  }
}

// .collapse {

//   .layout-logo-text {
//     display: none;
//   }
// }
</style>
